import { styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { SidebarContext } from 'src/contexts/SidebarContext'; // Adjust path if needed

// Define the prop types interface
interface LogoImageProps {
  size?: 'small' | 'medium' | 'large';
}

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  fontWeight: theme.typography.fontWeightBold,
  padding: theme.spacing(0.5), // Reduced padding
}));

// Use TypeScript with styled components
const LogoImage = styled('img')<LogoImageProps>(({ theme, size = 'large' }) => ({
  width: size === 'small' ? 100 : size === 'medium' ? 150 : 209, // Different size options
  height: 'auto', // Auto height to maintain aspect ratio
  marginLeft: theme.spacing(0.5), // Reduced margin
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1], // Lighter shadow
}));

// Props interface for the Logo component
interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  onClick?: () => void;
}

function Logo({ size = 'large', onClick }: LogoProps) {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  
  // Handle click for mobile menu toggle if needed
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <StyledLink to="/" onClick={handleClick}>
      <LogoImage
        src="/static/images/logo/logo.png"
        alt="mycatch logo"
        size={size}
      />
    </StyledLink>
  );
}

export default Logo;